import React, {useMemo} from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";


const Wrapper = styled.div``;
const LLMText = styled.span`
  font-weight: 700;
  font-size: 24px;
  color: ${props => props.theme.color.green_100};
  line-height: 29px;
`;
const LLMSmallText = styled.span`
  color: ${props => props.theme.color.dark_100};
  font-family: Pretendard;
  font-weight: 700;
  font-size: 20px;
`;
const LlmTextBox = ({list}) => {
    const {t} = useTranslation();
    return (
        <Wrapper>
            <LLMText>LLM <LLMSmallText>{t('llm.summary')}</LLMSmallText></LLMText>

            <ContentWrapper>
                <LLMLevelAdvantage obj={list?.levelAdvantage}/>
                <LLMTextContent list={list?.tips}/>
            </ContentWrapper>
        </Wrapper>
    );
};


const EmptyBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 24px;
`;

const EmptyAdvantage = styled.div`
  width: 16px;
  height: 16px;
  background-color: ${props => props.theme.color.green_100};
`;
const EmptyDisAdvantage = styled.div`
  width: 16px;
  height: 16px;
  background-color: ${props => props.theme.color.dark_300};
`;

const EmptyText = styled.span`
  margin-left: 8px;
  font-weight: 700;
  font-size: 14px;
  color: ${props => props.theme.color.dark_100};
`;


const AdvantageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px 0;
  gap: 4px;
`;

const AdvantageBox = styled.div`
  flex: 1;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: ${props => {
    let color = props.theme.color.dark_200
    if (props.advantage) {
      color = '#fff'
    }
    return color
  }};

  background-color: ${props => {
    let color = props.theme.color.default_border_color
    if (props.advantage) {
      color = props.theme.color.green_100
    }
    return color
  }};
`;

const LLMLevelAdvantage = ({obj}) => {
    const {t} = useTranslation();


    const levelAdvantageArray = useMemo(() => {
        try {
            const entries = Object.entries(obj)

            return entries.map((data, index) => {
                return {
                    title: index + 1,
                    value: data[1]
                }
            })

        } catch (e) {
            return []
        }
    }, [obj])


    if (!Array.isArray(levelAdvantageArray)) {
        return null
    }
    if (levelAdvantageArray.length < 1) {
        return null
    }

    return (
        <ItemWrapper>
            <ItemHeader>
                <ItemHeaderBar/>
                <ItemTextHeader>
                    {t('llm.timing')}

                </ItemTextHeader>
                <EmptyBox>
                    <EmptyAdvantage/>
                    <EmptyText>
                        {t('llm.advantages')}
                    </EmptyText>
                </EmptyBox>
                <EmptyBox>
                    <EmptyDisAdvantage/>
                    <EmptyText>
                        {t('llm.disAdvantages')}
                    </EmptyText>
                </EmptyBox>
            </ItemHeader>
            <ItemContentText>
                <AdvantageWrapper>
                    {levelAdvantageArray.map((data) => {
                        return (
                            <AdvantageBox key={data.title} advantage={data.value === '유리'}>
                                Level {data.title}
                            </AdvantageBox>
                        )
                    })}
                </AdvantageWrapper>

            </ItemContentText>
        </ItemWrapper>
    )
}

const ContentWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${props => props.theme.color.default_border_color};
  background-color: ${props => props.theme.color.white_201};
  padding: 16px 8px;
  border-radius: 4px;
  row-gap: 16px;
`;
const LLMTextContent = ({list}) => {


    if (list === null) {
        return <LLMTextItem content={'LLM 요약 준비 중'}/>
    }

    if (!Array.isArray(list)) {
        return (
            <LLMTextItem content={'ㅡ'}/>
        )
    }
    if (list.length === 0) {
        return (
            <LLMTextItem content={'ㅡ'}/>
        )
    }
    return (
        list.map((data, index) => {
            return (
                <LLMTextItem content={data.tip} title={data.title}
                             key={index}/>
            )
        })
    )
}
const ItemWrapper = styled.div`
  padding: 16px 10px;
  background-color: ${props => props.theme.color.site_main_color};
`;
const ItemHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  margin-bottom: 8px;
`;
const ItemHeaderBar = styled.div`
  width: 6px;
  height: 100%;
  background-color: ${props => props.theme.color.green_100};
`;
const ItemTextHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  padding: 0 16px 0 8px;
  background-color: ${props => props.theme.color.green_200};
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
  color: ${props => props.theme.color.green_100};
`;

const ItemContentText = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 25.6px;
  color: ${props => props.theme.color.dark_100};
`;

const LLMTextItem = ({title, content}) => {


    if (!title) {
        return (
            <ItemWrapper>
                <ItemContentText>
                    {content}
                </ItemContentText>
            </ItemWrapper>
        )
    }

    return (
        <ItemWrapper>
            <ItemHeader>
                <ItemHeaderBar/>
                <ItemTextHeader>
                    {title}
                </ItemTextHeader>
            </ItemHeader>
            <ItemContentText>
                {content}
            </ItemContentText>
        </ItemWrapper>
    )
}
export default LlmTextBox;